// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-box[data-v-434a837e] {\n  display: flex;\n}\n.list-box .main[data-v-434a837e] {\n  width: 50%;\n}\n.list-box .left[data-v-434a837e] {\n  padding-right: 20px;\n}\n.list-box .right[data-v-434a837e] {\n  padding-left: 20px;\n}\n.list-box .right .table[data-v-434a837e] {\n  height: 600px;\n}\n", ""]);
// Exports
module.exports = exports;
